import { Heading } from '@/components/v4';
import { styles } from '@/v5/@constants/login';

function TcapHeading({ children }) {
    return (
        <Heading as="h2" sx={styles.heading}>
            {children}
        </Heading>
    );
}

export { TcapHeading };
